import { Toaster as Sonner } from "sonner";
import { useTheme } from "@/context/ThemeContext";
import { useNativePlatform } from "@/hooks/useNativePlatform";
import { useIsMobile } from "@/hooks/use-mobile";
import { cn } from "@/lib/utils";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme } = useTheme();
  const { isNative } = useNativePlatform();
  const isMobile = useIsMobile();
  const useCompactStack = isMobile || isNative;

  return (
    <Sonner
      theme={theme}
      className={cn("toaster group bilenia-toast")}
      position="top-center"
      offset={
        isNative
          ? "calc(var(--native-safe-top, env(safe-area-inset-top, 0px)) + 0.5rem + 5px)"
          : "calc(env(safe-area-inset-top, 0px) + 0.75rem + 5px)"
      }
      closeButton
      duration={3500}
      richColors={false}
      // One toast at a time — stacking + hover-expand felt like "flapping" old notices
      visibleToasts={1}
      expand={false}
      gap={useCompactStack ? 3 : 6}
      toastOptions={{
        classNames: {
          toast: "bilenia-toast-item",
          title: "bilenia-toast-title",
          description: "bilenia-toast-description",
          actionButton: "bilenia-toast-action",
          cancelButton: "bilenia-toast-cancel",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
